
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const type19: IProductData = {
  id: "heiserman-type19",
  name: "Heiserman Audio Type 19",
  description: "Large Diaphragm Condenser Microphone",
  specialOrder: true,
  images: ["/img/heisermanaudio_type19_front.png"],
  details: [{
    label: "Description",
    markdown: `
Durable and versatile multi-pattern condenser microphone capturing the heart and soul of the U47 in a compact and versatile package.  

The Type-19 is a mic designed for working engineers who know that mixing starts with mic selection.  
Whether you’re recording drums, vocals, strings, or brass, the Type-19 will make your job easier.  
When you finally push up the faders after a long tracking session, you’ll know that tomorrow’s mix will be smooth and effortless — just like the Type-19.  
Handcrafted in the USA, and featuring unsurpassed quality and attention to detail — the new king of utility mics has arrived.  
`
  }, {
    label: "Features",
    markdown: `
- Stunning good looks with a softly glowing logo
- Switchable between Cardioid, Omni, and Fig 8 patterns
- High Pass Filter and -15 dB pad
- Designed, machined, assembled, and fully made in the USA
    `
  }, {
    label: "Specifications",
    markdown: `
- LENGTH | 5.5 in
- DIAMETER | 2 in
- POLAR PATTERN | Bi-Directional / Figure-Eight, Cardioid, Omni-Directional
- IMPEDANCE | 42 Ohms (output)
- FREQUENCY RANGE | 20 Hz - 20 kHz
- INPUT PAD | -15 dB
- FILTERS | 160 Hz high-pass
- MAX. SPL | 130 dB (145 dB with pad)
    `
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://heisermanaudio.com/products/type-19" target="_blank">https://heisermanaudio.com/products/type-19</a>
    `
  }],
  videos: [],
  metadata: {
    hashtags: [HASHTAGS.LIVE_SOUND, HASHTAGS.RECORDING, HASHTAGS.MICROPHONE],
    manufacturer: BRAND.HEISERMAN,
  }
}